import * as Yup from 'yup';

export const getEditOrganizationDetailsSchema = () => {
  return Yup.object().shape({
    companyName: Yup.string().required('Company Name is required'),
    industryType: Yup.string().required('Industry Type is required'),
    organizationContact: Yup.string()
      .matches(/^\+?[0-9\s\-()]{7,20}$/, 'Contact must be a valid phone number'),
    industrySize: Yup.string().required('Industry Size is required'),
    organizationAddress: Yup.string().required(
      'Organization Address is required',
    ),
  });
};
export const getUpdateCardDetailsSchema = () => {
  return Yup.object().shape({
    line1: Yup.string().required('Address 1 is required'),
    line2: Yup.string().required('Address 2 is required'),
    city: Yup.string().required('City is required'),
    state: Yup.string().required('State is required'),
    postal_code: Yup.string().required('Postal Code is required'),
    country: Yup.string().required('Country is required'),
    name: Yup.string().required('Name is required'),
  });
};
